export const blockInvoicesHeader = [
	{
		settings: true,
		text: "Invoice ID",
		value: "invoice_id",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "From",
		value: "from_date",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
		dense: true,
	},
	{
		settings: true,
		text: "To",
		value: "to_date",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
		dense: true,
	},
	{
		settings: true,
		text: "Total check",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		footer: "sum",
		dollar: true
	},
	{
		settings: true,
		text: "Paid amount",
		value: "paid_amount",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		footer: "sum",
		dollar: true
	},
	{
		settings: true,
		text: "Service",
		value: "services",
		filterable: false,
		sortable: true,
		left: false,
		dense: true
	},
	{
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View',
				icon: { value: 'icon_view', w: 20, h: 20 },
			}
		]
	},
];

export const defaultTabs = [
	{
		text: 'Previous invoices',
		type: 1,
		error: false,
	},
	{
		text: 'Not paid invoices',
		type: 2,
		error: false,
	}
];
